module.exports = __webpack_public_path__ + "assets/media/winter-night.011e5467.ogg";